import React, { useState, useEffect,useContext } from 'react'
import { Button, CardMedia, Dialog, Slide, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@mui/material'
import AddChu from './AddChu'
import { collection, query, orderBy, onSnapshot, deleteDoc, doc, getDoc, getDocs, writeBatch, where } from "firebase/firestore"
import { app, database, storage } from '../../../firebaseConfig'
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import EditChu from './EditChu'
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import ListServiceChu from './ListServiceChu'
import { DataGrid, GridActionsCellItem, GridToolbar, frFR } from '@mui/x-data-grid'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import dateFormat, { masks } from "dateformat";
import { deleteObject, ref } from 'firebase/storage'
import LinearProgress from '@mui/material/LinearProgress'
import { AuthContext } from '../../../AuthProvider';
import AccessDinied from '../../../components/AccessDinied';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});
function Chu() {
    const {user}=useContext(AuthContext)
    const [chus, setChus] = useState([])
    const [showAddModal, setShowAddModal] = useState(false)
    const [showEditModal, setShowEditModal] = useState(false)
    const [showServiceListModal, setShowServiceListModal] = useState(false)
    const [chu, setChu] = useState([])
    const [confirmDelete, setConfirmDelete] = useState(false)
    const [loadingData, setLoadingData] = useState(true)
    const handleCloseConfirm = () => {
        setConfirmDelete(false);
    };
    const columns = [
        {
            field: 'photo_chu',
            headerName: 'Photo',
            minWidth: 50,
            filterable: false,
            sortable: false,
            disableExport: true,
            renderCell: (params) => {
                return (
                    <CardMedia
                        component='img'
                        height="50"
                        image={params.value}
                        alt={params.row.nom_chu}
                        sx={{ marginTop: 1 }}
                    />
                )
            }
        },
        {
            field: 'nom_chu',
            headerName: 'Chu',
            width: 200,
            valueGetter: (value) => {
                return `${value.row.code_chu||''}-${value.row.nom_chu}`;
              },
          
        },
        { field: 'email_chu', headerName: 'Email', width: 250 },
        { field: 'contact_chu', headerName: 'Contact' },
        { field: 'nom_region', headerName: 'Province', width: 150 },
        { field: 'description_chu', headerName: 'Déscription' },
        {
            field: 'actions',
            type: 'actions',
            headerName: 'Actions',
            minWidth: 50,
            cellClassName: 'actions',
            getActions: (params) => {
                return [
                    <GridActionsCellItem icon={<MedicalServicesIcon color='success' />}
                        label="Service"
                        sx={{
                            color: 'primary.main',
                        }}
                        onClick={() => {
                            setChu(params.row)
                            setShowServiceListModal(true)
                        }} />,
                    <GridActionsCellItem icon={<EditIcon />}
                        label="Edit"
                        sx={{
                            color: 'primary.main',
                        }}
                        onClick={() => {
                            setChu(params.row)
                            setShowEditModal(true)
                        }} />,
                    <GridActionsCellItem icon={<DeleteIcon color='error' />}
                        label="Supprimer"
                        sx={{
                            color: 'primary.main',
                        }}
                        onClick={() => {
                            // handleDelete(params.id)
                            setConfirmDelete(true)
                            setChu(params.row)
                        }} />
                ]
            }
        }
    ]
    useEffect(() => {
        const q = query(collection(database, 'chu'), orderBy('code_chu', 'asc'))
        const unsubscribe = onSnapshot(q, (querySnapshot) => {
            const chusData = querySnapshot.docs.map(async (chuDoc) => {
                const chuData = chuDoc.data()
                const regionId = chuData.region_id
                const regionDocRef = doc(database, 'region', regionId);
                const regionDocSnapshot = await getDoc(regionDocRef);
                chuData.nom_region = regionDocSnapshot.data().nom
                return {
                    id: chuDoc.id,
                    ...chuData
                }
            })
            Promise.all(chusData).then((modifiedChus) => {
                setLoadingData(true)
                setChus(modifiedChus);
                setLoadingData(false)
            });
        })
        return () => unsubscribe();
    }, [])
    const handleDelete = async (id) => {
        const chuDocRef = doc(database, 'chu', id)
        try {
            await deleteServiceChu(id)
            await deleteReservation(id)
            await deleteDoc(chuDocRef)
            const imageRef = ref(storage, chu.photo_chu)
            await deleteObject(imageRef)
            if(chu.logo_chu != null && chu.logo_chu != '' ){
                const logoRef = ref(storage, chu.logo_chu)
               await deleteObject(logoRef)
            }
        } catch (err) {
            alert(err)
        }
    }
    const deleteServiceChu = async (idChu) => {
        const q = query(collection(database, 'service_chu'), where('chu_id', '==', idChu))
        const batch = writeBatch(database);
        const service_chu_refs = await getDocs(q);
        service_chu_refs.forEach((docChu) => {
            batch.delete(doc(database, "service_chu", docChu.id))
        })
        await batch.commit();
    }
    const deleteReservation = async (idService) => {
        const q = query(collection(database, 'reservation'), where('service_id', '==', idService))
        const batch = writeBatch(database);
        const service_chu_refs = await getDocs(q);
        service_chu_refs.forEach((docChu) => {
            batch.delete(doc(database, "reservation", docChu.id))
        })
        await batch.commit();
    }
    if(user.type !='Admin'){
        return <AccessDinied />
    }
    return (
        <div style={{ width: '100%', flexGrow: 1, overflow: 'hidden' }}>
            <Button variant="contained" size='small' onClick={() => { setShowAddModal(true) }} startIcon={<AddCircleOutlineIcon />}>
                Ajouter
            </Button>
            <div style={{ width: '100%', height: 450 }}>
                <DataGrid
                    rowSelection={false}
                    columns={columns}
                    rows={chus}
                    rowHeight={70}
                    sx={{ width: '100%', marginTop: 2 }}
                    initialState={{
                        pagination: {
                            paginationModel: {
                                pageSize: 10,
                            },
                        },
                    }}
                    pageSizeOptions={[10, 25, 100]}
                    localeText={frFR.components.MuiDataGrid.defaultProps.localeText}
                    loading={loadingData}
                    slots={{
                        toolbar: GridToolbar,
                        loadingOverlay: LinearProgress,
                    }}
                    slotProps={{
                        toolbar: {
                            printOptions: { disableToolbarButton: true },
                            csvOptions: {
                                fileName: 'chu_csv_' + dateFormat(new Date(), 'yyyymmddHHMMss'),
                                delimiter: ',',
                                utf8WithBom: true,
                            }
                        }
                    }}
                />
            </div>
            {showAddModal &&
                <AddChu onClose={() => setShowAddModal(false)} open={showAddModal} list={chus} />
            }
            {showEditModal &&
                <EditChu onClose={() => setShowEditModal(false)} open={showEditModal} data={chu} list={chus} />
            }
            {showServiceListModal &&
                <ListServiceChu onClose={() => setShowServiceListModal(false)} open={showServiceListModal} data={chu} />
            }
            <Dialog
                open={confirmDelete}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleCloseConfirm}
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle>Suppression!</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                        Cette action pourra entrainer la perte d'autres données relatives à celle-ci.<br />
                        Cliquez sur confirmer, si vous voulez continuer.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseConfirm}>Annuler</Button>
                    <Button
                        variant='contained'
                        color='error'
                        onClick={() => {
                            handleDelete(chu.id)
                            setConfirmDelete(false)
                        }}>Confirmer</Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default Chu